import { useState } from 'react';
import useStore from '../../../helpers/useStore';
import { BIContext } from '../../../stores/BIDashboard/biDashboard.provider';

interface UseSendToEmailParams {
  csvData: string;
  filename: string;
  subject: string;
  recipientEmail: string;
}

interface UseSendToEmailResult {
  sendEmail: (params: UseSendToEmailParams) => Promise<{ success: boolean } | null>;
  isLoading: boolean;
  error: string | null;
}

const useSendToEmail = (): UseSendToEmailResult => {
  const BIStore = useStore(BIContext);
  const { sendBIReportCSVEmail } = BIStore;

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendEmail = async (params: UseSendToEmailParams) => {
    try {
      setIsLoading(true);
      setError(null);

      return await sendBIReportCSVEmail(
        params.csvData,
        params.filename,
        params.subject,
        params.recipientEmail
      );

    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || 'Fehler beim Senden der E-Mail';
      setError(errorMessage);
      console.error('Error sending email:', err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { sendEmail, isLoading, error };
};

export default useSendToEmail;